import { toast as toastify, ToastOptions } from 'react-toastify';

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error'
}

export const toast = (type: ToastType, text: string, options?: ToastOptions) => toastify[type](text, options);
